import React, { useEffect } from 'react';
import { Controller, UseControllerProps } from 'react-hook-form';
import { Checkbox, FormControl, FormControlLabel, FormHelperText, styled, Switch, SwitchProps, SxProps, Theme } from '@mui/material';
import { WSIcons } from '../../commonFunctions/iIcons'
interface ControlledCheckBoxFieldProps {
  label?: string;
  id: string;
  name: string;
  className?: string;
  disabled?: boolean;
  control: any;
  defaultValue?: any;
  rules: UseControllerProps['rules'];
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  setValue?: any;
  reset?: any,
  isMobile?: boolean;
  sx?: SxProps<Theme>;
  isTickIcon?: boolean,
    switchType?:'Default' | 'IOS'
}

const WSSCheckBoxField: React.FC<ControlledCheckBoxFieldProps> = ({
  id,
  label,
  className,
  control,
  name,
  rules,
  disabled = false,
  defaultValue = false,
  setValue,
  onChange,
  reset,
  isMobile = false,
  sx,
  isTickIcon = false,
  switchType="Default",
}) => {
  useEffect(() => {
    if (setValue) {
      setValue(name, defaultValue);
    }
  }, [setValue, name, defaultValue]);
 const IOSSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#65C466',
          opacity: 1,
          border: 0,
          ...theme.applyStyles('dark', {
            backgroundColor: '#2ECA45',
          }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: theme.palette.grey[100],
        ...theme.applyStyles('dark', {
          color: theme.palette.grey[600],
        }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.7,
        ...theme.applyStyles('dark', {
          opacity: 0.3,
        }),
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: '#E9E9EA',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
      ...theme.applyStyles('dark', {
        backgroundColor: '#39393D',
      }),
    },
  }));
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}

      render={({ field, fieldState }) => (
        <FormControl className={className} disabled={disabled} error={!!fieldState.error}>
          <FormControlLabel
          
            control={
              isMobile && switchType==='Default'? 
               (
                <Switch
                  
                  {...field}
                  checked={field.value}
                  onChange={(event) => {
                    if (onChange) {
                      onChange(event);
                    }
                    field.onChange(event.target.checked);
                  }}
                  sx={{
                    transform: 'scale(1.1)', // Adjust switch scale if needed
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                      backgroundColor: '#CEEEE5',
                    },
                      '& .MuiSwitch-switchBase': {
                        '&.Mui-checked': {
                          color: '#098963', // Customize switch color when checked
                        },
                      },

                    }
                  }
                    />
              ) : isMobile && switchType==='IOS'?<>  
               <IOSSwitch
                  sx={{marginLeft:1}}
                  {...field}
                  checked={field.value}
                  onChange={(event) => {
                    if (onChange) {
                      onChange(event);
                    }
                    field.onChange(event.target.checked);
                  }}
                
                
                    /></>:(<Checkbox
                {...field}
                checked={field.value}
                id={id}
                icon={isTickIcon ? <WSIcons.UntickIcon sx={{ color: 'darkgreen', fontWeight: 'bold' }} /> : undefined}
                checkedIcon={isTickIcon ? <WSIcons.TickIcon sx={{ color: 'darkgreen', fontWeight: 'bold' }} /> : undefined}
                onChange={(event) => {

                  if (onChange) {
                    onChange(event)
                  }
                  field.onChange(event.target.checked);
                }}
                sx={{
                  ...sx,
                  transform: 'scale(1.1)', // Reduce the size of the checkbox
                  '& .MuiSvgIcon-root': {
                    fontSize: '1rem', // Adjust icon size
                  },
                }}

              // onChange={(event) => {
              //   field.onChange(event);
              //   if (onChange) {
              //     onChange(event);
              //   }
              // }}
              />
              )}
            label={<span style={{ fontSize: '0.75rem',paddingLeft:3 }}>{label}</span>}
            sx={{
              '& .MuiFormControlLabel-label': {
                fontSize: '0.75rem' // Adjust font size for label text
              }
            }}
          //  labelPlacement={switchType==='IOS'?'start':'end'}
          />
          {fieldState.error && <FormHelperText sx={{ fontSize: '0.75rem' }}>{fieldState.error.message}</FormHelperText>} {/* Reduced error message size */}
        </FormControl>
      )}
    />
  );
};

export default WSSCheckBoxField;
